const CONTACT = {
    whatsapp: 'https://wa.me/5391665255',
    email: 'contato@whizr.app',
};

export default CONTACT